import styled from 'styled-components';

export const ContainerStyle = styled.div`
  width: calc(100% - 48px);
  display: flex;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  flex-direction: column;
  justify-content: center;

  &.hidden {
    opacity: 0;
    width: 1px;
  }
`;

export const Style = styled.div`
  .w-header {
    display: flex;
    gap: 5%;
    margin: 0px var(--size-lg);

    .cont {
      display: flex;
      justify-content: space-between;
      gap: 5%;
      flex: 1;

      label {
        color: #344054;
        font-size: var(--font-size-lg);
        font-weight: 500;
        margin-bottom: 0px;
      }
    }
  }
`;
